import { useTranslation } from "react-i18next";
import { ChangedArea } from "../../../../autogen/bff-api";

export const useChangedAreaLabel = (): ((area: ChangedArea) => string) => {
  const { t } = useTranslation();
  return (area) => {
    switch (area) {
      case ChangedArea.Title:
        return t("Title");
      case ChangedArea.Deadline:
        return t("Bid deadline");
      case ChangedArea.Description:
        return t("Description");
      case ChangedArea.Documents:
        return t("Competition documents");
      case ChangedArea.ReferenceId:
        return t("Reference number");
      case ChangedArea.AwardCriteria:
        return t("Award criteria");
      case ChangedArea.MinimumRequirements:
        return t("Minimum requirements");
      case ChangedArea.PriceModel:
        return t("Price model");
      case ChangedArea.ContractTerms:
        return t("Contract terms");
      case ChangedArea.Products:
        return t("Products");
      case ChangedArea.DpsValidity:
        return t("New end of validity");
    }
  };
};
